import state from './door.state'
import mutations from './door.mutations'
import actions from './door.actions'

export default {
  state,
  mutations,
  actions
}
